import React from "react";
import { Sun, Moon, Monitor, Check } from "lucide-react";
import { useTheme } from "@/shared/context/ThemeContext";
import SubPageShell from "@/apps/rider/components/SubPageShell";

const OPTIONS = [
  { id: "system", label: "System",  hint: "Match your device", Icon: Monitor },
  { id: "light",  label: "Light",   hint: "Cream + navy",       Icon: Sun },
  { id: "dark",   label: "Dark",    hint: "Deep navy",          Icon: Moon },
];

export default function AppearancePrefs() {
  const { preference, setPreference, theme } = useTheme() || {};
  return (
    <SubPageShell
      eyebrow="Preferences"
      title="Appearance"
      subtitle={`Currently rendering in ${theme || "light"} mode.`}
      back="/account"
      backLabel="Account"
      testId="appearance-page"
    >
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5" role="radiogroup" aria-label="Appearance">
        {OPTIONS.map(({ id, label, hint, Icon }) => {
          const selected = preference === id;
          return (
            <button
              key={id}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => setPreference?.(id)}
              data-testid={`appearance-${id}`}
              data-selected={selected}
              className={`text-left p-4 rounded-2xl border transition-colors ${
                selected
                  ? "bg-[#0A1128] text-[#F9F7F4] border-[#0A1128]"
                  : "bg-white text-[#0A1128] border-[#E5E1D8] hover:border-[#ed6500]/50"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className={`w-10 h-10 inline-flex items-center justify-center rounded-xl ${
                  selected ? "bg-white/10 text-[#ed6500]" : "bg-[#FCEADE] text-[#ed6500]"
                }`}>
                  <Icon size={16} />
                </span>
                {selected && <Check size={14} className="text-[#ed6500]" strokeWidth={2.4} />}
              </div>
              <div className="font-semibold text-[15px] mt-3">{label}</div>
              <div className={`text-[11.5px] mt-0.5 ${selected ? "text-[#F9F7F4]/70" : "text-[#515E7B]"}`}>
                {hint}
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-[#515E7B] mt-4">
        Appearance applies to this browser. Sign in on another device to set it there too.
      </p>
    </SubPageShell>
  );
}
